
import React , { useState , useEffect } from 'react'; 
import { Card } from 'primereact/card';

import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';

export default function FilterDetail( { setQ1 , setQ2 , show , procesado}) {
    const [telefono,setTelefono] = useState( "" )
    const [iccid,setIccid] = useState( "" )
    const [dateactivacion,setDateactivacion] = useState( null )
    const [estatus,setEstatus] = useState( "")
    const [dateprimerevento,setdateprimerevento] = useState( null )
    const [dateexpiracion,setdateexpiracion] = useState( null )
    const [dateprimerrecarga,setdateprimerrecarga] = useState( null )
    const [dateultimarecarga,setdateultimarecarga] = useState( null )
    const [numerorecargas,setnumerorecargas] = useState( null )
    const [numerorecargasmax,setnumerorecargasmax] = useState( null )
    const [diasrecargados,setdiasrecargados] = useState( null )
    const [diasrecargadosmax,setdiasrecargadosmax] = useState( null )
    const [saldo,setsaldo] = useState( null )
    const [saldomax,setsaldomax] = useState( null )

    const [query1,setQuery1] = useState(null)
    const [query2,setQuery2] = useState(null)

    useEffect(() => {

        console.log( "dateactivacion = " , dateactivacion )

    } ,[dateactivacion])

    useEffect(() => {

        console.log( "show = ****** " , show )

        setTelefono("")
        setIccid("")
        setDateactivacion (null)
        setEstatus("")
        setdateprimerevento(null)
        setdateexpiracion(null) 
        setdateprimerrecarga(null)
        setdateultimarecarga(null) 
        setnumerorecargas(null)
        setnumerorecargasmax(null)
        setdiasrecargados(null) 
        setsaldo(null) 
        setQuery1( null )
        setQuery2( null )

        setQ1( "")
        setQ2( "")

    } ,[show])


    useEffect(() => {

        console.log( "telefono = " , telefono )

    } ,[telefono])



    function onProcesar()
    {
        var query = query2 ; // Aqui estamos sobre query2

        



        console.log( "Vamos a procesar el query = " , query2 )

        console.log( "telefono = " , telefono )

        console.log( "iccid = " , iccid )



        console.log( "query = " , query )

        if ( telefono === "" && iccid === "" && dateactivacion === null && 
            dateprimerevento === null && estatus === "" && dateexpiracion === null &&
            dateprimerrecarga === null && dateultimarecarga === null && numerorecargas === null &&
            numerorecargasmax === null && diasrecargados === null && diasrecargadosmax === null && 
            saldo === null && saldomax === null 
        )
        {
            //return ;

            console.log( "Procesando con null")

            procesado( null ) 

            return ; 
        }

        var obj = {
            query1 : "" ,
            query2 : ""
        }




        if ( query1 === null )
        {

            query = " where "

            if ( telefono !== "" )
            {
                query+= " master.numero = '" + telefono +"' "
            }

            if ( iccid !== "" )
            {
                if ( query === " where " ) 
                {
                    query+= " master.iccid = '" + iccid +"' "
                }
                else{
                    query += " and master.iccid = '" + iccid + "'"
                }
            }


            if ( dateactivacion !== null && dateactivacion.length > 1 )
                {
                    if ( query === " where " ) 
                    {
                        query+= " detalle.fechaactivacion >= '" + getFormatDate(dateactivacion[0]) +"' and detalle.fechaactivacion <= '" + getFormatDate(dateactivacion[1]) +"'"
                    }
                    else{
                        query += " and detalle.fechaactivacion >= '" + getFormatDate(dateactivacion[0]) + "' and detalle.fechaactivacion <= '" + getFormatDate(dateactivacion[1]) +"'"
                    }
            }


            if ( dateprimerevento !== null && dateprimerevento.length > 1 )
                {
                    if ( query === " where " ) 
                    {
                        query+= " detalle.fechaprimerevento >= '" + getFormatDate(dateprimerevento[0]) +"' and detalle.fechaprimerevento <= '" + getFormatDate(dateprimerevento[1]) +"'"
                    }
                    else{
                        query += " and detalle.fechaprimerevento >= '" + getFormatDate(dateprimerevento[0]) + "' and detalle.fechaprimerevento <= '" + getFormatDate(dateprimerevento[1]) +"'"
                    }
            }


            if ( dateexpiracion !== null && dateexpiracion.length > 1 )
                {
                    if ( query === " where " ) 
                    {
                        query+= " detalle.fechaexpiracion >= '" + getFormatDate(dateexpiracion[0]) +"' and detalle.fechaexpiracion <= '" + getFormatDate(dateactivacion[1]) +"'"
                    }
                    else{
                        query += " and detalle.fechaexpiracion >= '" + getFormatDate(dateprimerevento[0]) + "' and detalle.fechaexpiracion <= '" + getFormatDate(dateactivacion[1]) +"'"
                    }
            }

            // dateprimerrecarga

            if ( dateprimerrecarga !== null && dateprimerrecarga.length > 1 )
                {
                    if ( query === " where " ) 
                    {
                                       //fechaprimerrecarga
                        query+= " master.fechaprimerrecarga >= '" + getFormatDate(dateprimerrecarga[0]) +"' and master.fechaprimerrecarga <= '" + getFormatDate(dateprimerrecarga[1]) +"'"
                    }
                    else{
                        query += " and master.fechaprimerrecarga >= '" + getFormatDate(dateprimerrecarga[0]) + "' and master.fechaprimerrecarga <= '" + getFormatDate(dateprimerrecarga[1]) +"'"
                    }
            }

            // dateultimarecarga

            if ( dateultimarecarga !== null && dateultimarecarga.length > 1 )
            {
                    if ( query === " where " ) 
                    {
                        query+= " master.fechaultimarecarga >= '" + getFormatDate(dateultimarecarga[0]) +"' and master.fechaultimarecarga <= '" + getFormatDate(dateultimarecarga[1]) +"'"
                    }
                    else{
                        query += " and master.fechaultimarecarga >= '" + getFormatDate(dateultimarecarga[0]) + "' and master.fechaultimarecarga <= '" + getFormatDate(dateultimarecarga[1]) +"'"
                    }
            }

            // numerorecargas

            if ( numerorecargas !== null && numerorecargasmax !== null )
                {
                    if ( numerorecargas === numerorecargasmax )
                    {
                        if ( query === " where " ) 
                        {
                            query+= " detalle.numeroderecargas = " + numerorecargas 
                        }
                        else{
                            query += " and detalle.numeroderecargas = " + numerorecargas 
                        }

                    }
                    else{

                        if ( query === " where " ) 
                        {
                            query+= " detalle.numeroderecargas >= " + numerorecargas + " and detalle.numeroderecargas <= " + numerorecargasmax
                        }
                        else{
                            query += " and detalle.numeroderecargas = '" + numerorecargas + " and detalle.numeroderecargas <= " + numerorecargasmax
                        }
                    }
                }

            // diasrecargados

            if ( diasrecargados !== null && diasrecargadosmax !== null )
                {

                        if ( diasrecargados === diasrecargadosmax )
                        {

                            if ( query === " where " ) 
                            {
                                query+= " detalle.diasrecargados = " + diasrecargados 
                            }
                            else{
                                query += " and detalle.diasrecargados = " + diasrecargados 
                            }

                        }
                        else{
                            if ( query === " where " ) 
                            {
                                query+= " detalle.diasrecargados >= " + diasrecargados + " and detalle.diasrecargados <= " + diasrecargadosmax
                            }
                            else{
                                query += " and detalle.diasrecargados >= " + diasrecargados + " and detalle.diasrecargados <= " + diasrecargadosmax
                            }
                    }
                }


            if ( saldo !== null && saldomax === null )
                {
                        if ( query === " where " ) 
                        {
                            query+= " master.saldo >= " + saldo + " and master.saldo <= " + saldomax
                        }
                        else{
                            query += " and master.saldo >= '" + saldo + " and master.saldo <= " + saldomax
                        }
                }



            //query = " where numero = '" + telefono + "' "

            if ( query === ' where ')
            {
                query = ""
            }

            console.log( "query = " + query )

            setQuery2( query ) ;

            setQ2( query )

            obj.query1 = query ;

            

        }
        else {
            console.log( "por el else")
            query += " where numero = '" + telefono + "' "
            setQuery2( query ) ;
        }


        procesado(obj) ;
    }


    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
          ("00" + date.getHours()).slice(-2) + ":" +
          ("00" + date.getMinutes()).slice(-2) + ":" +
          ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
      
        return dateStr;
      }

    return (
        <div className="card">
            

                <div className=' flex mt-5 ' 
                    style={{justifyContent:'space-around' , flexWrap :'wrap ' , gap : '20px' }}>

                    <FloatLabel className='mt-5'>
                        <InputText id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                        <label htmlFor="telefono">Teléfono</label>
                    </FloatLabel>

                    <FloatLabel className='mt-5'>
                        <InputText id="iccid" value={iccid} onChange={(e) => setIccid(e.target.value)} />
                        <label htmlFor="iccid">Iccid</label>
                    </FloatLabel>


                    <div className="flex flex-column gap-2 mb-2">
                        <label htmlFor="dateactivacion">Fecha Activación</label>
                            <Calendar dateFormat='yy-mm-dd' selectionMode="range"
                                id="dateactivacion" value={dateactivacion} onChange={(e) => setDateactivacion(e.value)} showIcon />

                    </div>


                    <FloatLabel className='mt-5'>
                        <InputText id="estatus" value={estatus} onChange={(e) => setEstatus(e.target.value)} />
                        <label htmlFor="estatus">Estatus</label>
                    </FloatLabel>

                    <div className="flex flex-column gap-2 mb-2">
                        <label htmlFor="dateprimerevento">Fecha Primer Evento</label>
                            <Calendar dateFormat='yy-mm-dd' selectionMode="range"
                                id="dateprimerevento" value={dateprimerevento} onChange={(e) => setdateprimerevento(e.value)} showIcon />

                    </div>

                    <div className="flex flex-column gap-2 mb-2">
                        <label htmlFor="dateexpiracion">Fecha de expiracion</label>
                            <Calendar dateFormat='yy-mm-dd' selectionMode="range"
                                id="dateexpiracion" value={dateexpiracion} onChange={(e) => setdateexpiracion(e.value)} showIcon />

                    </div>


                    <div className="flex flex-column gap-2 mb-2">
                        <label htmlFor="dateprimerrecarga">Fecha primer Recarga</label>
                            <Calendar dateFormat='yy-mm-dd' selectionMode="range"
                                id="dateprimerrecarga" value={dateprimerrecarga} onChange={(e) => setdateprimerrecarga(e.value)} showIcon />

                    </div>

                    <div className="flex flex-column gap-2 mb-2">
                        <label htmlFor="dateultimarecarga">Fecha ultima Recarga</label>
                            <Calendar dateFormat='yy-mm-dd' selectionMode="range"
                                id="dateultimarecarga" value={dateultimarecarga} onChange={(e) => setdateultimarecarga(e.value)} showIcon />

                    </div>


                    <FloatLabel>
                        <InputNumber id="numerorecargas" value={numerorecargas} onValueChange={(e) => setnumerorecargas(e.value)} />
                            <label htmlFor="numerorecargas">Número de Recargas Min</label>
                    </FloatLabel>

                    <FloatLabel>
                        <InputNumber id="numerorecargasmax" value={numerorecargasmax} onValueChange={(e) => setnumerorecargasmax(e.value)} />
                            <label htmlFor="numerorecargasmax">Número de Recargas Max</label>
                    </FloatLabel>

                    <FloatLabel>
                        <InputNumber id="diasrecargados" value={diasrecargados} onValueChange={(e) => setdiasrecargados(e.value)} />
                            <label htmlFor="diasrecargados">Dias Recargados Min</label>
                    </FloatLabel>


                    <FloatLabel>
                        <InputNumber id="diasrecargadosmax" value={diasrecargadosmax} onValueChange={(e) => setdiasrecargadosmax(e.value)} />
                            <label htmlFor="diasrecargadosmax">Dias Recargados Max</label>
                    </FloatLabel>

                    <FloatLabel>
                        <InputNumber id="saldo" value={saldo} onValueChange={(e) => setsaldo(e.value)} />
                            <label htmlFor="saldo">Saldo Min</label>
                    </FloatLabel>

                    <FloatLabel>
                        <InputNumber id="saldomax" value={saldomax} onValueChange={(e) => setsaldomax(e.value)} />
                            <label htmlFor="saldomax">Saldo Max</label>
                    </FloatLabel>

                </div>

                <div className='flex justify-content-center mt-4'>

                    <Button onClick={onProcesar} label="Procesar"></Button>

                </div>

           
        </div>
    )
}
        